import Axios from "axios";
import {initCompanyForm} from "./form";
import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initCompaniesEdit() {

	const companyForm = initCompanyForm(document.querySelector('.company-form'));

	document.querySelector('.update-company-button').onclick = updateCompany;

	function updateCompany() {
		const companyData = companyForm.inputs();

		companyForm.clearFeedbacks();

		loading();

		Axios.post(companyForm.postUrl(), companyData)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initCompaniesEdit}
